<app-accordion [isOpen]="isOpen" [headerText]="selectedTypeName | translate">
  <div class="field-type-options gap-md flex-responsive col-4 no-flex-grow p-md">
    @for (fieldType of availableFieldTypes; track fieldType.value) {
    <app-radio name="fieldTypeSelector" [value]="fieldType.value" [(ngModel)]="selectedFieldType"
      (ngModelChange)="onTypeSelected($event)" [label]="fieldType.label | translate"
      [attr.data-testid]="'field-type-radio-' + fieldType.value" />
    }
  </div>
</app-accordion>